import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FocusIssueSelectDisplay } from './FocusIssueSelectDisplay';

interface Props {
  value?: string;
  previousValue?: string | null;
  onClose: () => void;
  fieldName: string;
  submissionContextId: string;
}

export const FocusIssueSelectDiffModal = ({
  value,
  previousValue,
  onClose,
  fieldName,
  submissionContextId
}: Props) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No data available
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={fieldName}>
        {prevZeroState ? (
          zeroState
        ) : (
          <FocusIssueSelectDisplay
            value={previousValue}
            submissionContextId={submissionContextId}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={fieldName}>
        {currentZeroState ? (
          zeroState
        ) : (
          <FocusIssueSelectDisplay
            value={value}
            submissionContextId={submissionContextId}
          />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
